// Special combo prices
const specialCombinations = [
  {
    primary_meat_id: 1, // Corned beef
    secondary_meat_id: 11, // Chop liver
    combo_price: 17.99
  }
];

export default specialCombinations;